<template>
  <div class="container">
    <heard :title="'语言评估'" ref="heard" />
    <div class="content">
      <aside class="nav-sidebar">
        <div class="nav-title">目录</div>
        <ul class="nav-list">
          <li
            v-for="item in navItems"
            :key="item.id"
            :class="['nav-item', 'nav-level-' + item.level, { active: activeNav === item.id }]"
            @click="scrollTo(item.id)"
          >
            {{ item.text }}
          </li>
        </ul>
      </aside>
      <main class="main-content">
        <div class="markdown-body" ref="markdownBody" v-html="renderedHtml"></div>
      </main>
    </div>
    <foot />
  </div>
</template>

<script>
import { marked } from "marked";
import heard from "../components/heard.vue";
import foot from "../components/footer.vue";

export default {
  name: "Mmcgdmd",
  data() {
    return {
      renderedHtml: "",
      navItems: [],
      activeNav: "",
    };
  },
  mounted() {
    this.fetchMarkdown();
  },
  beforeDestroy() {
    if (this._observer) {
      this._observer.disconnect();
    }
  },
  methods: {
    async fetchMarkdown() {
      try {
        const response = await fetch("/mmcgd2.md");
        const markdown = await response.text();
        this.renderWithNav(markdown);
      } catch (error) {
        this.renderedHtml = "<p>加载文档失败</p>";
      }
    },
    renderWithNav(markdown) {
      const tokens = marked.lexer(markdown);
      const navItems = [];
      let headingCounter = 0;

      this._walkAndAssignIds(tokens, (token) => {
        if (token.type === "heading") {
          headingCounter++;
          const id = "heading-" + headingCounter;
          navItems.push({
            id,
            text: this._stripHtml(token.text),
            level: token.depth,
          });
          return id;
        }
        return null;
      });

      this.navItems = navItems;

      const renderer = new marked.Renderer();
      let renderCounter = 0;
      renderer.heading = (text, level) => {
        renderCounter++;
        const id = "heading-" + renderCounter;
        return `<h${level} id="${id}">${text}</h${level}>`;
      };

      this.renderedHtml = marked.parser(tokens, { renderer });

      this.$nextTick(() => {
        this.observeHeadings();
      });
    },
    _walkAndAssignIds(tokens, callback) {
      for (const token of tokens) {
        const id = callback(token);
        if (id) token._anchorId = id;
        if (token.tokens) this._walkAndAssignIds(token.tokens, callback);
      }
    },
    _stripHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || "";
    },
    observeHeadings() {
      const el = this.$refs.markdownBody;
      if (!el) return;
      const headings = el.querySelectorAll("h1[id], h2[id], h3[id]");
      if (headings.length === 0) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.activeNav = entry.target.id;
            }
          });
        },
        { rootMargin: "-80px 0px -60% 0px" }
      );
      headings.forEach((h) => this._observer.observe(h));
    },
    scrollTo(id) {
      this.activeNav = id;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
  components: {
    heard,
    foot,
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 100vh;
  .content {
    height: calc(100vh - 108px);
    display: flex;
    background: #97bd97;
  }
}

.nav-sidebar {
  width: 260px;
  min-width: 260px;
  height: 100%;
  overflow-y: auto;
  border-right: 1px solid #97bd97;
  background: #97bd97;
  padding: 20px 0;
  user-select: none;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2px;
  }

  .nav-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    padding: 0 24px 16px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 8px;
  }

  .nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-item {
    padding: 8px 24px;
    font-size: 20px !important;
    // color: #666;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: normal !important;
    border-left: 3px solid transparent;

    &:hover {
      color: #568156;
      background: #f0f5f0;
    }

    &.active {
      color: #568156;
      background: #e8f0e8;
      border-left-color: #568156;
      // font-weight: bold; 
       font-family: "宋体";
    }

    &.nav-level-1 {
      // font-weight: bold;
        font-family: "宋体";
    }

    &.nav-level-2 {
      padding-left: 40px;
      font-size: 20px;
        font-family: "宋体";
        font-weight: normal !important;
    }

    &.nav-level-3 {
      padding-left: 56px;
      font-size: 20px;
        font-family: "宋体";
        font-weight: normal !important;
    }
  }
}

.main-content {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 30px 50px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
}
.markdown-body {
  max-width: 90%;
  margin:10px auto;
  line-height: 1.8;
  font-size: 20px !important;
  color: #333;
    // font-weight: bold ;
    font-family: "宋体" !important;

  img {
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  h1 {
    // font-size: 20px !important;
    border-bottom: 2px solid #97bd97;
    padding-bottom: 10px;
    margin: 30px 0 20px;
  }

  h2 {
    // font-size: 20px !important;
    margin: 30px 0 15px;
    color: #568156;
    padding-left: 10px;
    border-left: 4px solid #97bd97;
  }

  h3 {
    // font-size: 20px !important;
    margin: 20px 0 10px;
  }

  p {
    margin: 10px 0;
    // font-size:20px !important;
    font-weight: bold;
    font-family: "宋体";

  }

  ul, ol {
    padding-left: 24px;
    margin: 10px 0;
  }

  li {
    margin: 5px 0;
  }

  code {
    background: #f4f4f4;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 14px;
  }

  pre {
    background: #f4f4f4;
    padding: 15px;
    border-radius: 5px;
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
    }
  }

  blockquote {
    border-left: 4px solid #97bd97;
    padding-left: 16px;
    color: #666;
    margin: 15px 0;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 15px 0;

    th, td {
      border: 1px solid #ddd;
      padding: 8px 12px;
    }

    th {
      background: #97bd97;
      color: #fff;
    }
  }
}
</style>
